import classNames from 'classnames';
import type { SyntheticEvent } from 'react';

import { Layout, Space, Typography } from '@sravni/react-design-system';
import { Image } from '@sravni/react-image';
import { useBoolean } from '@sravni/react-utils';

import { ebsImagePng } from '@src/assets';

import { EbsDialogBanner } from '../EbsDialogBanner/EbsDialogBanner';

import { EbsBannerTexts } from './EbsBanner.texts';
import styles from './EsbBanner.module.scss';

export function EbsBanner() {
  const [isShow, setShow] = useBoolean(false);

  const handleClose = () => {
    setShow.off();
  };

  return (
    <>
      <Layout className={classNames('layout', styles.outsideContainer)} onClick={setShow.on}>
        <div className={styles.container}>
          <Space direction="column" size={4}>
            <Typography.Heading as="div" level={5} className={classNames('h-color-static-light', styles.heading)}>
              {EbsBannerTexts.heading}
            </Typography.Heading>
            <Typography.Text as="div" className={classNames('h-color-static-light', styles.subtitle)}>
              {EbsBannerTexts.description}
              <span className={styles.helper}>{EbsBannerTexts.howToDo}</span>
            </Typography.Text>
          </Space>
          <Space className={styles.imageContainer}>
            <Image src={ebsImagePng} />
          </Space>
        </div>
      </Layout>
      <EbsDialogBanner visible={isShow} onClose={handleClose} data={undefined} onOverlayClick={handleClose} />
    </>
  );
}
